import nBossConnection from 'modules/base/service/nBossConnection';
import UserDto from 'app/admin/user/dto/UserDto';
import AccessConfigDto from 'app/admin/user/dto/AccessConfigDto';

class AccessManagementService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'accessManagement';
	}

	/**
	 * @return {Promise<Object|null>}
	 */
	getState() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getState`)
				.then(response => resolve(response?.data ?? null))
				.catch(reject);
		});
	}

	/**
	 * @param {string} email
	 * @param {string} password
	 * @return {Promise<boolean>}
	 */
	login(email, password) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/login`, {
					email,
					password
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<UserDto>}
	*/
	getLoggedInClient() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getLoggedInClient`)
				.then(response => resolve(new UserDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<string>}
	 */
	getLoggedInClientName() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getLoggedInClientName`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<string>}
	 */
	getRole() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getRole`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} role
	 * @return {Promise<Object|boolean>}
	 */
	changeRole(role) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeRole`, { role })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} userGroupId
	 * @return {Promise<Object|boolean>}
	 */
	changeUserGroup(userGroupId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeUserGroup`, { userGroupId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} userGroupId
	 * @return {Promise<Object|boolean>}
	 */
	setActiveUserGroupId(userGroupId) {
		return this.changeUserGroup(userGroupId);
	}

	/**
	 * @return {Promise<boolean>}
	 */
	logout() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/logout`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<boolean>}
	 */
	isLoggedIn() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/isLoggedIn`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<AccessConfigDto>}
	 */
	getAccessConfig() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getAccessConfig`)
				.then(response => resolve(new AccessConfigDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<Object>}
	 */
	getServiceRolesMap() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getServiceRolesMap`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AccessManagementService();
